module.exports = __webpack_public_path__ + "static/media/gavvista.bd49fcb0.png";